/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetBuyerAccountRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetBuyerAccountResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getBuyerAccount = (request: GetBuyerAccountRequest, options?: CashRequestOptions) => post<GetBuyerAccountRequest, GetBuyerAccountResponse>("/cash-app/local/get-buyer-account", request, {...options, rejectOnError: true })